<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-data-table
                :headers="headers"
                :items="items"
                :items-per-page="10"
                :options.sync="options"
                :loading="isLoading"
                :server-items-length="totalItems"
                item-key="orderNumber"
                show-expand
                :single-expand="true"
                class="elevation-1 registrations-data-table"
                :loading-text="$t('loadingPleaseWait')"
                :no-data-text="$t('noData')"
                :footer-props="footerProps"
                :header-props="headerProps"
        >
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="py-4">
                    <sales-data-extend
                            :order="item"
                            :fields="expandFields"
                            :contracts="contracts"
                            @remove="remove"
                            @save="save"
                    ></sales-data-extend>
                </td>
            </template>
        </v-data-table>
        <snack-delete
            :is-open="snackOpen"
            :snack-color="snackColor"
            :snack-delete="snackDelete"
            :snack-text="snackText"
            @close-snack="closeSnack"
            @remove="removeOrder"
        ></snack-delete>
    </div>
</template>

<script>
    import AppSnack from '../../../../general/mixins/AppSnack';
    import SalesDataExtend from './SalesDataExtend';
    import SnackDelete from '../../snacks/SnackWithDelete';
    import OrderService from '../../../../app-front/services/api/OrderService';
    import ContractsService from '../../../../app-front/services/api/ContractsService';

    export default {
        name: "ProfileSales",
        props: ['filters'],
        mixins:[AppSnack],
        components: {
            SalesDataExtend,
            SnackDelete
        },
        data() {
            return {
                contracts: [],
                currentOrder: null,
                expandFields: {},
                headers: [],
                items: [],
                isLoading: false,
                options: {},
                page: 0,
                totalItems: null,
                footerProps: {
                    'items-per-page-text': this.$t('rowsPerPage'),
                    'items-per-page-all-text': this.$t('all'),
                    'page-text': /*this.$t('from')*/ '',
                },
                headerProps: {
                    sortByText: this.$t('sortBy'),
                }
            }
        },
        computed: {
            itemsFilters() {
                return this.filters;
            }
        },
        methods:{
            getContracts() {
                ContractsService.getTableData()
                    .then(res => {
                        this.contracts = res.data;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            remove(order) {
                this.currentOrder = order;
                this.resetSnack();
                this.setSnackText(this.$t('doYouWantToDeleteSale'));
                this.setDeleteSnack();
                this.setDeleteSnackState();
                this.openSnack();
            },
            removeOrder() {
                OrderService.deleteOrder(this.currentOrder.id)
                    .then(res => {
                        this.page--;
                        this.items = [];
                        this.setItems();
                        this.resetSnack();

                        if(res.error) {
                            this.setDeleteSnack();
                            this.setSnackText(this.$t('orderRemoveError'));
                            this.openSnack();
                        } else {
                            this.setSuccessSnack();
                            this.setSnackText(this.$t('orderRemoveSuccess'));
                            this.openSnack();
                        }
                        window.scrollTo(0, 0);
                    })
                    .catch(err => {
                        this.setDeleteSnack();
                        this.setSnackText(this.$t('orderRemoveError'));
                        this.openSnack();
                    })
            },
            save(order) {
                this.currentOrder = order;
                this.resetSnack();
                this.setInfoSnack();
                this.setConfirmSnackState();
                this.updateOrder();
            },
            setTable() {
                OrderService.setLocale(this.$store.state.language.appLanguage);
                OrderService.getSellerTableData()
                    .then(res => {
                        this.headers = res.data.headers;
                        this.expandFields = res.data.fields;
                    })
                    .catch(err => {
                        console.log(err);
                    });
            },
            setItems() {
                if(this.isLoading) {
                    return;
                }

                this.loading = true;

                const params = {...this.options, filters: this.filters};

                OrderService.setLocale(this.$store.state.language.appLanguage);
                OrderService.getListSales(params)
                    .then(res => {
                        this.items = res.data.data;
                        this.totalItems = res.data.total;
                        this.isLoading = false;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            updateItemsList() {
                const idx = this.items.findIndex(item => item.id === this.currentOrder.id);

                if(idx > -1) {
                    this.items[idx] = this.currentOrder;
                }

                this.currentOrder = null;
            },
            updateOrder() {
                OrderService.updateOrder(this.currentOrder)
                    .then(res => {
                        this.currentOrder = null;
                        this.loading = false;
                        this.setItems();
                        this.resetSnack();
                        this.setSuccessSnack();
                        this.setSnackText(this.$t('orderUpdated'));
                        this.openSnack();
                        window.scrollTo(0, 0);
                    })
                    .catch(err => {
                        this.currentOrder = null;
                        this.resetSnack();
                        this.setDeleteSnack();
                        this.setSnackText(this.$t('orderUpdatedError'));
                        this.openSnack();
                    });
            },
        },
        created() {
            this.setTable();
            this.getContracts();
        },
        watch: {
            itemsFilters: {
                handler() {
                    this.setItems();
                },
                deep: true
            },
            options: {
                handler() {
                    if(Object.keys(this.itemsFilters).length) this.setItems();
                },

                deep: true
            }
        }
    }
</script>
